// ======== We need this in order to store token from express to memory store =======
/* eslint-disable import/no-anonymous-default-export */
export default {
  token: null,

  setToken(token) {
    this.token = token;
  },
};
